import { UNASSIGNED_ASSIGNEE } from '../constants/common';

export type AssigneeOption = { id?: string | number };

// Agents who can't re-assign may still claim an unassigned lead when
// self-assignment is on, but only for themselves: the backend rejects any
// other assignee.
export const resolveAssigneeAccess = <T extends AssigneeOption>({
  options,
  assigneeId,
  isAssigneeSelectionDisabled,
  isSelfAssignEnabled,
  currentUserId
}: {
  options: T[];
  assigneeId?: string | null;
  isAssigneeSelectionDisabled: boolean;
  isSelfAssignEnabled: boolean;
  currentUserId: string;
}) => {
  const isSelfOnly =
    isAssigneeSelectionDisabled && isSelfAssignEnabled && !assigneeId;
  return {
    isDisabled: isAssigneeSelectionDisabled && !isSelfOnly,
    options: isSelfOnly
      ? options.filter(
          (option) =>
            option.id === UNASSIGNED_ASSIGNEE.id || option.id === currentUserId
        )
      : options
  };
};
